const deleteAttachment = (fundingRequest, fileId) => (
  dispatch,
  getState,
  { api, schema }
) => api.factoring.deleteFactoringAttachment(fundingRequest, fileId);

export default deleteAttachment;
